import {
  Timeout,
  YMOptions,
  OrderWrappingModParameters, Location, Country
} from '~/types/types'

import {BASE_DOMAIN_MAIN} from '~/composables/useVzFetch';
import {priceFormat} from "~/common/price";

// time '18:00' format
export function objTime(time: string) {
  if (!time) {
    return 0
  }
  const times = time.split(':')
  if(+times[1] >= 0) {
    return {hour: +times[0], minute: +times[1]}
  }
  return time || 0
}

// форматируем 5123123 -> '5 123 123'
export function formatPrice(price: number | string) {
  if(typeof price === 'number') {
    price = priceFormat(price.toFixed(2))
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function scrollToElem(
  elemClass: string,
  options: ScrollIntoViewOptions = {
    behavior:'smooth',
    block: 'center',
    inline: 'center'
  }
) {
  nextTick( () => {
    if ( document ) {
    const elem = document.querySelector(elemClass)
    if ( elem ) {
      elem.scrollIntoView({
        behavior: options.behavior,
        block: options.block,
        inline: options.inline
      })
    }}
  })
}

export function debounce(timeout: Timeout, callBack: () => void, delay = 300): Timeout {
  if (timeout) {
    clearTimeout(timeout)
  }
    return setTimeout(async () => {
        await callBack()
    }, delay)
}


export function clearEmpties(obj?: Record<string, any> | null, deep = false): any {
  if (!obj) {
    return obj
  }
  if (Array.isArray(obj)) {
    return obj.length ? obj : null
  }

  const newObj = { ...obj }
  Object.entries(obj).forEach(([key, value]) => {
    const isObject = typeof value === 'object'
    if (deep && isObject) {
      newObj[key] = clearEmpties(newObj[key], true)
    }
    if (!newObj[key] || (isObject && !Object.values(newObj[key]).filter(v => v !== undefined).length)) {
      delete newObj[key]
    }
  })
  return newObj
}

export function objectExcludeKeys(obj: any, keys: string[]) {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
}

// возвращает массив пересечения по коду key
export function getUniqueCommonItems(arrays, key) {
  if (!Array.isArray(arrays) || arrays.length === 0)
    return []

  let existInAll = false
  const seenItems = new Set()

  return arrays[0].filter(item => {
    if (seenItems.has(item[key]))
      return false

    const existsInAll = arrays.every(arr => arr.some(i => i[key] === item[key]))

    if (existsInAll) {
      seenItems.add(item[key]);
      return true
    }

    return false
  })
}

// проверяет одинаковы ли 2 массива с простыми объектами(без вложенности) по длине и элементам
export function isArraysOfObjectsEqual(a, b) {
  if (a.length !== b.length) return false;

  const serialize = obj => JSON.stringify(obj);
  const sortedA = a.map(serialize).sort();
  const sortedB = b.map(serialize).sort();

  return sortedA.every((val, i) => val === sortedB[i]);
}

export const deepCopyObject = <T>(obj: T): T => {
  try {
    if (!obj) {
      return obj
    }
    return JSON.parse(JSON.stringify(obj))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error({ error: 'Ошибка преобразования объекта в функции deepCopyObject', rawErorr: e, obj })
    return obj
  }
}

export const declOfNum = (number: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
}

export function getDomain(host = '') {
  // host = host || ((process.client && window) ? window.location?.hostname : BASE_DOMAIN_MAIN as string) || ''
  host = host || ((process.client && window) ? window.location?.hostname : (useNuxtApp().ssrContext?.event.node.req.headers.host || BASE_DOMAIN_MAIN) as string) || ''
  if (host.includes('localhost')) {
    // http потом удалится, это просто для удобства удаления порта
    let url = new URL(`https://${host}`)
    url.port = ''
    host = url.hostname
  }
  const parts = host.split('.')
  return `${parts.length > 2 ? `${parts.slice(-2).join('.')}` : parts.join('.')}`
}

export function cookieOptions(host: string|undefined = undefined) {
  return {
    maxAge: 10000000,
    // sameSite: true,
    secure: true,
    domain: `.${getDomain(host)}`
  }
}

export function removeUrlParam (key: string, sourceURL: string) {
  let rtn = sourceURL.split('?')[0]
  let param
  let paramsArr: string[] = []
  const queryString = (sourceURL.includes('?')) ? sourceURL.split('?')[1] : ''
  if (queryString !== '') {
    paramsArr = queryString.split('&')
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split('=')[0]
      if (param === key) {
        paramsArr.splice(i, 1)
      }
    }
    if (paramsArr.length > 0) {
      rtn = rtn + '?' + paramsArr.join('&')
    }
  }
  return rtn
}

export function getFullLinkRedirect (city: Partial<Location>, link: string, host = '', setCity = '') {
  if (!city || !link) { return '' }

  let abbr = city.abbr || city.translit || ''
  if (city.rcl_guid) {
    abbr = ''
  }
  host = host || ((process.client && window) ? window.location?.host : (useNuxtApp().ssrContext?.event.node.req.headers.host || BASE_DOMAIN_MAIN) as string) || ''
  const endDomain = link[0] === '/' ? '' : '/'
  const domain = getNewDomainLink(abbr, city.country || '', host) + endDomain
  if (link.includes('set_city')) {
    link = removeUrlParam('set_city', link)
  }

  const end = link.substr(-1) === '/' ? '' : (!link.includes('?') && !link.includes('&') ? '/' : '')
  link = link + end
  if (!host.includes('.' + city.country?.toLowerCase()) /*&& !host.includes('localhost')*/) {
    link = link + (link.includes('?') ? '&' : '?') + 'set_city=' + (setCity || abbr)
  }
  return domain + link
}

function getNewDomainLink(abbr: string, country: string, host = ''): string {
  // const domain = abbr && !['msk', 'minsk', 'ekaterinburg', 'nur-sultan', 'almaty', 'astana', 'karaganda', 'bishkek'].includes(abbr)
  //     ? abbr + '.'
  //     : ''
  const domain = ''
  const hostArr = host.split('.')

  /** Удаляем текущий поддомен */
  if (hostArr.length === 3) {
    hostArr.splice(0, 1)
  }
  const currentDomain = hostArr[hostArr.length - 1]

  /** Переадресация на Страны. Если это не dev, xyz, org и не local */
  if (![country?.toLowerCase(), 'dev', 'xyz', 'org'].includes(currentDomain) && !currentDomain.includes('localhost')) {
    hostArr[hostArr.length - 1] = country?.toLowerCase()
  }
  host = hostArr.join('.')

  return '//' + domain + host
}

export function getCountryByPhone(phone: string, strict = true): Country|false {
  if (phone.includes('@')) {
    return false
  }

  phone = phone.replace(/\D/g, '')
  if (phone.startsWith('375') && (phone.length === 12 || !strict)) {
    return 'BY'
  }
  if (phone.startsWith('996') && (phone.length === 12 || !strict)) {
    return 'KG'
  }
  if ((phone.length === 11 || !strict) && (phone.startsWith('77') || phone.startsWith('76') || phone.startsWith('87') || phone.startsWith('86'))) {
    return 'KZ'
  } else if ((phone.length === 11 || !strict) && (phone.startsWith('7') || phone.startsWith('8'))) {
    return 'RU'
  }
  return false
}

export const promiseDelay = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function getModCheckFunction(type: OrderWrappingModParameters['conditions']): (valueLeft: number, valueRight: number) => boolean {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let fc = (valueLeft: number, valueRight: number): boolean => false
  switch (type) {
    case '>=':
      fc = (valueLeft: number, valueRight: number): boolean => {
        return valueLeft >= valueRight
      }
      break
    default:
  }
  return fc
}

export function setYM(id: number, name: string, options?: YMOptions): void {
  const { params, domain, withDelay } = options || {}

  console.log(`name: ${name}, options: ${JSON.stringify(options)}`)

  // проверяем соответствие домена, если необходимо
  if (domain) {
    const d = import.meta.env?.VITE_ENV_DOMAIN || getDomain()
    if (!d.includes(domain)) {
      return
    }
  }

  const sendGoal = () => {
   if (typeof window === 'undefined' || typeof window.ym === 'undefined') {
      console.warn(`[ym] ym не определён или это не клиент`)
      return
    }

    try {
      let goalParams: Record<string, any> | undefined = undefined

      if (name === '404') {
        const ref = document.referrer
        const siteUrl = document.location.href
        goalParams = { NotFoundURL: { [siteUrl]: { referrer: ref } } }
      } else {
        goalParams = params
      }

      window.ym(id, 'reachGoal', name, goalParams)
      console.log(`[ym] цель отправлена: ${name}`, goalParams || '')
    } catch (e) {
      console.error(`[ym] ошибка при отправке цели "${name}":`, e)
    }
  }

  // выполняем с задержкой, если необходимо
  if (withDelay) {
    setTimeout(sendGoal, 1000)
  } else {
    sendGoal()
  }
}

export function getDeepValue(o: any, p: string) {
  return p.split('.').reduce((a, v) => a?.[v] || '', o)
}

export function getNextFocusEl(allFocusEl, activeFocusEl) {
  try {
    const index = [...allFocusEl]?.indexOf(activeFocusEl);
    if (index >= 0) {
      return allFocusEl[index + 1] || allFocusEl[0] as HTMLElement
    }
  } catch (error) {
    console.log('Problem with focus')
  }
}

const year = new Date().getFullYear()
export const orderNumberPlaceholder = `${year.toString().slice(-2)}0******`
